import { Image, Paper, Stack, Text } from '@mantine/core';
import React from 'react';
import AssetsLogin from './AssetsLogin';

const LeftSection = () => {
  return (
    <Paper
      radius='xl'
      visibleFrom='md'
      h={'100%'}
      pos={'relative'}
      py={80}
      px={50}
      bg={'primary.0'}
    >
      <AssetsLogin />
      <Stack style={{ zIndex: 2 }} pos={'relative'} h={'100%'}>
        <Image src='/logo/horizontal_logos.svg' h={40} w={305} />
        <Stack justify='center' pos={'absolute'} bottom={270} maw={480}>
          <Text fz={32} fw={'bold'} lh={1.5}>
            Empower your educational vision with DACUM 2.0.
          </Text>
          <Text>
            Transform curriculum development across BINUS units with our intuitive platform,
            designed to simplify complex educational planning in minutes.
          </Text>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default LeftSection;
